import React from "react";
import {SearchBox} from "@elastic/react-search-ui";

const SearchHeader = ({ setSearchTerm }) => {
  return (
    <div className="search-header">
      <div className="search-header__container">
        <div className="search-header__logo">
          <svg xmlns="http://www.w3.org/2000/svg" width="90" height="115" viewBox="0 0 90 115" fill="none">
            <path
              d="M38.5934 106.833L44.0482 113.695C44.5059 114.266 45.3833 114.266 45.841 113.695L51.2958 106.833C51.6391 106.414 51.6391 105.842 51.2958 105.422L45.841 98.5607C45.3833 97.9889 44.5059 97.9889 44.0482 98.5607L38.5934 105.422C38.2501 105.842 38.2501 106.414 38.5934 106.833Z"
              fill="black"/>
            <path
              d="M37.5635 8.74832L44.0482 0.552363C44.506 -0.019448 45.3833 -0.019448 45.841 0.552363L52.3257 8.7102C52.669 9.12952 52.669 9.70133 52.3257 10.1207L45.841 18.2785C45.3833 18.8503 44.506 18.8503 44.0482 18.2785L37.5635 10.1207C37.2202 9.70133 37.2202 9.12952 37.5635 8.7102V8.74832Z"
              fill="black"/>
            <path
              d="M0.257481 58.4959L5.71225 65.3576C6.17 65.9294 7.04734 65.9294 7.50508 65.3576L12.9599 58.4959C13.3032 58.0765 13.3032 57.5047 12.9599 57.0854L7.50508 50.2237C7.04734 49.6518 6.17 49.6518 5.71225 50.2237L0.257481 57.0854C-0.0858269 57.5047 -0.0858269 58.0765 0.257481 58.4959Z"
              fill="black"/>
            <path
              d="M77.0439 58.4959L82.4986 65.3576C82.9564 65.9294 83.8337 65.9294 84.2915 65.3576L89.7462 58.4959C90.0895 58.0765 90.0895 57.5047 89.7462 57.0854L84.2915 50.2237C83.8337 49.6518 82.9564 49.6518 82.4986 50.2237L77.0439 57.0854C76.7006 57.5047 76.7006 58.0765 77.0439 58.4959Z"
              fill="black"/>
            <path
              d="M36.3047 58.4959L44.0482 68.2548C44.506 68.8266 45.3833 68.8266 45.841 68.2548L53.5845 58.4959C53.9278 58.0765 53.9278 57.5047 53.5845 57.0854L45.841 47.3265C45.3833 46.7547 44.506 46.7547 44.0482 47.3265L36.3047 57.0854C35.9614 57.5047 35.9614 58.0765 36.3047 58.4959Z"
              fill="black"/>
            <path
              d="M59.1156 34.2892L63.2735 39.5499C63.7312 40.1217 64.6086 40.1217 65.0663 39.5499L69.2623 34.2892C69.6056 33.8699 69.6056 33.2981 69.2623 32.8787L65.1044 27.6181C64.6467 27.0463 63.7694 27.0463 63.3116 27.6181L59.1156 32.8787C58.7723 33.2981 58.7723 33.8699 59.1156 34.2892Z"
              fill="black"/>
            <path
              d="M18.4146 34.2892L24.8993 42.447C25.357 43.0189 26.2344 43.0189 26.6921 42.447L33.1768 34.2892C33.5201 33.8699 33.5201 33.2981 33.1768 32.8787L26.6921 24.7209C26.2344 24.1491 25.357 24.1491 24.8993 24.7209L18.4146 32.8787C18.0713 33.2981 18.0713 33.8699 18.4146 34.2892Z"
              fill="black"/>
            <path
              d="M56.2547 82.6263L63.2353 91.4322C63.693 92.004 64.5703 92.004 65.0281 91.4322L72.0468 82.6263C72.3901 82.207 72.3901 81.6351 72.0468 81.2158L65.0662 72.4099C64.6085 71.8381 63.7311 71.8381 63.2734 72.4099L56.2547 81.2158C55.9114 81.6351 55.9114 82.207 56.2547 82.6263Z"
              fill="black"/>
            <path
              d="M19.4064 82.6644L24.8612 89.5261C25.3189 90.0979 26.1963 90.0979 26.654 89.5261L32.1088 82.6644C32.4521 82.245 32.4521 81.6732 32.1088 81.2539L26.654 74.3922C26.1963 73.8204 25.3189 73.8204 24.8612 74.3922L19.4064 81.2539C19.0631 81.6732 19.0631 82.245 19.4064 82.6644Z"
              fill="black"/>
          </svg>
        </div>
        <div className="search-header__input-wrapper">
          <span className="search-header__icon-search">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
              <path
                  d="M17.4588 2.99499C15.5265 1.06277 12.9541 -0.000518799 10.2215 -0.000518799C7.48897 -0.000518799 4.91649 1.06277 2.98428 2.99499C-0.194161 6.17343 -0.925888 11.1583 1.23499 15.1485L1.62372 15.8231L1.74949 16.0403C1.80665 16.1432 1.88669 16.2004 2.01245 16.2347L3.16721 16.5434C3.31584 16.5777 3.43017 16.5091 3.46447 16.3719L3.77317 15.2171C3.80747 15.1028 3.7846 14.9999 3.72744 14.897L3.60167 14.6798L3.22438 14.0395C1.56656 10.9754 2.12679 7.09952 4.59636 4.62994C6.09412 3.13219 8.09493 2.29756 10.2215 2.29756C12.3481 2.29756 14.3375 3.12075 15.8352 4.62994C18.9336 7.72835 18.9336 12.7704 15.8352 15.8802C13.3657 18.3498 9.50122 18.91 6.45998 17.2751L5.85402 16.9207L5.56819 16.7492C5.46529 16.692 5.36239 16.6806 5.24806 16.7034L4.0933 17.0007C3.94467 17.035 3.87607 17.1608 3.9218 17.298L4.21907 18.4527C4.25337 18.5671 4.31053 18.6585 4.41343 18.7157L4.63066 18.8414L5.33952 19.253C6.86014 20.0762 8.5294 20.4764 10.1872 20.4764C12.8512 20.4764 15.4922 19.4474 17.4473 17.4923C21.4375 13.5021 21.4375 7.00805 17.4473 3.01786L17.4588 2.99499Z"
                  fill="black"/>
              <path
                  d="M20.2941 18.8414L20.1111 18.6585C20.0311 18.5785 19.9282 18.5327 19.8139 18.5327H18.6248C18.4762 18.5327 18.3733 18.6242 18.3733 18.7843V19.9733C18.3733 20.0991 18.419 20.1906 18.4991 20.2706L18.682 20.4535L26.388 28.1595L28.0001 26.5474L20.2941 18.8414Z"
                  fill="black"/>
            </svg>
          </span>

        <SearchBox
            autocompleteMinimumCharacters={3}
            autocompleteResults={{
              sectionTitle: "Results",
              titleField: "job_title",
              shouldTrackClickThrough: true,
            }}
            autocompleteSuggestions={true}
            inputProps={{
              placeholder: "Search jobs and keywords",
              className: "search-header__input"
            }}
            onSelect={(selection) => {
              if (selection && selection.job_title?.snippet) {
                const selectedJobTitle = selection.job_title.snippet[0].replace(/<\/?em>/g, "");
                setSearchTerm(selectedJobTitle, {shouldClearFilters: true});
              }
            }}
        />
      </div>
    </div>
    </div>
  );
};
export default SearchHeader;
